import React from 'react';
import { SanityCenterTextSection } from 'graphql-types';
import * as styles from './centerTextSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { Blocks } from '../ui/blocks/Blocks';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityCenterTextSection;
}

export const CenterTextSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  return (
    <div
      className={`${styles.wrapper} ${section?.activeButton && styles.wrapperB} ${
        section?.activeTitle && styles.wrapperT
      } ${section?.activeText && styles.wrappert}`}
      data-colorbg={section.backgroundColor}
    >
      <Blocks blocks={findTranslation(section?._rawCenterTextTitleSection, lang, defaultLang)} />
    </div>
  );
};
